export const colorsTableauVisiteQualite = {
    black: 'black',
    orange: 'orange',
    green: 'green'
}